import React, { Component } from 'react';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import namelogo from "./namelogo.png";
import Paper from 'material-ui/Paper';
import { withStyles } from 'material-ui/styles';
import Tabs, { Tab } from 'material-ui/Tabs';
import SwipeableViews from 'react-swipeable-views';
import Market from './Market';
import Holdings from './Holdings';
import TransactionSnackbar from './TransactionSnackbar';
import AccountDisplay from './AccountDisplay';

const styles = theme => ({
  root: theme.mixins.gutters({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    display: 'flex',
    flexDirection: 'column'
  }),
  main: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16
  }),
  formControl: {
    minWidth: 120
  }
});

class App extends Component {

  state = {
    tab: 0,
    alerts: []
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  handleTabChange = (event, tab) => {
    this.setState({ tab });
  }

  handleSwipe = tab => {
    this.setState({ tab });
  };

  render() {
    const { classes, theme } = this.props;
    const { tab } = this.state;
    return (
      <div className={classes.root}>
        <AppBar position="static" color="default">
          <Toolbar>
            <img src={namelogo} alt="optionality.io" style={({height: '40px'})}/>
            <div style={({flex:1, display:'flex', justifyContent:'center'})}>
            <Tabs value={tab} onChange={this.handleTabChange}>
               <Tab label="Market"/>
               <Tab label="Holdings"/>
             </Tabs>
            </div>
            <AccountDisplay/>
          </Toolbar>
        </AppBar>
        <Paper style={({flex:1})} className={classes.main}>
          <SwipeableViews axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'} index={tab} onChangeIndex={this.handleSwipe}>
            <Market/>
            <Holdings/>
          </SwipeableViews>
        </Paper>
        <TransactionSnackbar/>
      </div>
    )
  }
}

export default withStyles(styles, { withTheme: true })(App);


// WEBPACK FOOTER //
// ./src/App.js